export const hasRole = (roles, targetRole) => {
  return roles?.includes(targetRole);
}; 